<template>
    <div id="create-campaign">
        <div class="app-container my-5" v-show="!$global.loading">
            <div class="d-flex justify-content-between">
                <div class="page-title mb-3">
                    <router-link to="/campaigns">
                        <span class="breadcrumb-link">
                            <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Campagnes
                        </span>
                    </router-link>
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span class="breadcrumb-item">
                        <div v-if="!update">
                            <v-icon class="breadcrumb-item-icon">mdi-calendar-arrow-right</v-icon> Programmation
                            d'une
                            relance
                        </div>
                        <div v-else>
                            <span v-if="campaign.batches.length > 1">
                                <v-icon class="breadcrumb-item-icon">edit</v-icon> Modification d'une relance
                            </span>
                            <span v-else>
                                <v-icon class="breadcrumb-item-icon">edit</v-icon> Modification d'un 1er envoi
                            </span>
                        </div>
                    </span>
                </div>

                <div>
                    <v-btn @click="openPreview" outlined color="primary">
                        <v-icon class="mr-2">remove_red_eye</v-icon>
                        Voir le formulaire
                    </v-btn>
                </div>
            </div>

            <v-text-field v-model="campaign.name" background-color="white" readonly label="Nom de votre campagne"
                          outlined>
            </v-text-field>

            <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
                <v-stepper-header>
                    <v-stepper-step editable step="1">
                        Prestataires ({{ providers.length }})
                    </v-stepper-step>

                    <v-stepper-step editable step="2">
                        Contenu de l'e-mail
                    </v-stepper-step>

                    <v-stepper-step editable step="3">
                        Finaliser
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <verification v-if="providers.length" :is-revival="true" :providers="providers"
                                      :contacts="contacts">
                        </verification>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <email v-if="providers.length"></email>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <finalize :providers="providers" :cadh-name="campaign.name" :is-revival="true"
                                  v-if="providers.length" :update-mode="update" :batch-id="campaign.last_batch.id"
                                  :cadh-id="cadhId" :cadh="campaign" :criterias="criterias">
                        </finalize>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Verification from "./stepers/Verification"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import Options from "./stepers/Options"
import * as EmailValidator from "email-validator"

export default {
    name: "CadhRevival",
    props: ["updateMode"],
    components: { Finalize, Email, Verification, Options },
    data() {
        return {
            cadhId: null,
            campaign: {
                batches: [],
                state: {
                    code: "WAIT_FIRST_SENT",
                },
            },
            contacts: [],
            update: false,
            configToken: null,
            criterias: [],
        }
    },
    methods: {
        ...mapMutations("createCadh", [
            "setSender", "setFirstPartMail", "setLastPartMail", "setSubject", "setSignature", "setSentAt",
            "setEndAt", "setEmailsValid", "setEmailsWrong", "setProviders", "setCurrentStep", "setNoEmail",
            "resetState", "setCadhType", "setSingleEmail", "setSelectedCriterias", "setCadhConfigId"
        ]),
        getCadh() {
            this.$global.loading = true

            this.$http.get("auth/campaigns/cadh/providers/" + this.cadhId).then(res => {
                this.campaign = res.body.data.cadh

                let batch = this.campaign.last_batch

                if (this.update) {
                    let start = this.$moment(batch.sent_at)

                    this.setSentAt(start)
                }
                if (this.campaign.batches.length === 1 && window.location.href.indexOf("update") > -1) {
                    // Cas update 1er envoi
                    if (this.campaign.type === "OBJ") {
                        this.setProviders(batch.providers)
                    } else {
                        this.setProviders(batch.entities)
                    }
                } else {
                    // Cas création relances et update relances
                    if (this.campaign.type === "OBJ") {
                        this.setProviders(batch.providers_not_answered)
                    } else {
                        this.setProviders(batch.entities_not_answered)
                    }
                }

                this.setFirstPartMail(batch.email_part1)
                this.setLastPartMail(batch.email_part2)
                this.setSender(this.campaign.sender)
                this.setSubject(batch.email_subject)
                this.setSignature(this.campaign.sender.signature)
                this.setNoEmail(this.campaign.no_email)
                this.setSingleEmail(this.campaign.single_email)
                this.setEmailLists()
                this.setCadhType(this.campaign.type)
                this.setCadhConfigId(this.campaign.cadh_configuration_id)

                let criterias = this.campaign.apidae_criterias.map(criteria => criteria.external_id)

                this.setSelectedCriterias(criterias)
                this.getLastConfig()

                this.$global.loading = false
            })
        },
        getContacts() {
            this.$http.get("auth/account/contacts").then(res => {
                this.contacts = res.body.data.contacts
            })
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = "Email non renseigné"
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
        openPreview() {
            let url = window.location.origin + "/cadh-preview/" + this.configToken

            window.open(url)
        },
        getLastConfig() {
            this.$http.get("auth/campaigns/cadh/cadh-config-infos/" + this.campaign.cadh_configuration_id).then(res => {
                this.configToken = res.body.data.configToken
            })
        },
        getInternalCriterias() {
            return this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias
            })
        },
    },
    computed: {
        ...mapState("account", ["senders", "account"]),
        ...mapState("createCadh", ["providers", "currentStep"]),
    },
    created() {
        let hash = this.$route.params.hash
        this.cadhId = parseInt(atob(hash))

        if (this.$route.path.includes("update")) {
            this.update = true
        }

        this.resetState()

        this.$store.dispatch("account/loadSenders").then(() => {
            if (this.senders.length) {
                this.setSender(this.senders[0])
            }
        })

        this.getCadh()
        this.getContacts()
        this.getInternalCriterias()

        this.$global.$on("change-step", (step) => {
            this.currentStep = step
        })
    },
    destroyed() {
        this.$global.$off("change-step")
    },
}
</script>